
import { useState } from 'react';
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface SaveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (name: string) => void;
}

const SaveDialog = ({ open, onOpenChange, onSave }: SaveDialogProps) => {
  const [name, setName] = useState('');
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Plattegrond opslaan als</DialogTitle>
          <DialogDescription>
            Voer een naam in voor de plattegrond
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Naam plattegrond"
            />
          </div>
          <Button onClick={() => {
            onSave(name);
            onOpenChange(false);
            setName('');
          }}>
            Opslaan
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SaveDialog;
